export default "__VITE_ASSET__Bv3ts_jL__"